module.exports = {"pathContext":{"_PARENT":"SOURCE"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/contact.json
// module id = 363
// module chunks = 184662623972074